import { AxiosInstance } from 'axios';
import { CreateBookParams } from '../../../views/dashboard/CreateBookModal/CreateBookModal';
import { CreateTemplateParams } from '../../types/apiType';

class BookService {
  constructor(private ApiClient: AxiosInstance) {}

  create = async (params: CreateBookParams) => {
    const { data } = await this.ApiClient.post('/books', params);
    return data;
  };

  list = async (type?: string) => {
    const { data } = await this.ApiClient.get('/books');
    return data;
  };

  submitPage = async (params: { bookId: string; id: string; ownerId: string }) => {
    const { data } = await this.ApiClient.put('/books/submit-page', params);
    return data;
  };

  invitePage = async (params: { bookId: string; ids?: string[]; userId: string; indexes?: number[] }) => {
    const { data } = await this.ApiClient.put('/books/invite-page', params);
    return data;
  };

  exportPdf = async (bookId: string, isPreview: boolean = false) => {
    const { data } = await this.ApiClient.post('/books/export-pdf', { bookId, isPreview });
    return data;
  };

  checkoutBook = async (params: { book_id: string; name: string; bookPrice: number }) => {
    const data = await this.ApiClient.post('/books/checkout-book', params);
    return data;
  };

  requestDeleteBook = async (params: { book_id: string }) => {
    const data = await this.ApiClient.post('/books/request-delete-book', params);
    return data;
  };

  archiving = async (params: { book_id: string }) => {
    const data = await this.ApiClient.put('/books/archiving', params);
    return data;
  };

  deleteArchivedBook = async (params: { id: string; isTemplate: boolean }) => {
    const data = await this.ApiClient.delete('/books/archiving', { params });
    return data;
  };

  createTemplate = async (params: { book_id: string; template: CreateTemplateParams }) => {
    const data = await this.ApiClient.put('/books/archiving', params);
    return data;
  };

  restore = async (params: { id: string }) => {
    const data = await this.ApiClient.post('/books/restore', params);
    return data;
  };

  submitTemplateToReview = async (params: { id: string; type: 'book' | 'page' }) => {
    const data = await this.ApiClient.post('/books/template/submit-to-review', params);
    return data;
  };

  templateReview = async (params: { id: string; userId: string; type: string }) => {
    const data = await this.ApiClient.post('/books/template/review', params);
    return data;
  };

  createSystemTemplate = async (params: { id: string; systemTemplateId: string; book_id: string; template: CreateTemplateParams }) => {
    const data = await this.ApiClient.post('/books/template/system', params);
    return data;
  };

  getSystemTemplate = async () => {
    const data = await this.ApiClient.get('/books/template/system');
    return data;
  };

  updateCoverThumbnail = async ({ bookId, pageId }: { bookId: string; pageId: string }) => {
    await this.ApiClient.post('/books/update-thumbnail', { bookId, pageId });
  };
}

export default BookService;
